import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const cohortDetailsApi = createAsyncThunk(
    'auth/cohorts/details',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.cohortDetailsAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const cohortDetailsSlice = createSlice({
    name: 'cohort details',
    initialState: { result: {}, loading: false, error: null, message: "" },
    reducers: {
        resetcohort: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(cohortDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(cohortDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(cohortDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetcohort } = cohortDetailsSlice.actions;
export const cohortDetailsReducer = cohortDetailsSlice.reducer